import api from '@/plugins/api'
import { statement, statementManual } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
import { formData } from '@/configs/dates'
import { generateFilterParams } from '@/configs/helpers'
import router from '@/router'

const store = 'statement'

export default {
  state: () => ({
    statements: {},
    clientStatements: {},
    clientStatement: {},
    counterClientStatement: {},
    statement: {},
    decision: {},
    files: [],
    isLoad: false,
    isDisabledStatementSubmit: false,
    vinDecodeInfo: {
      info: null,
      error: null
    },
    euroCodes: [],
    identificationAct: {},
    vehicleCategories: [],
    transportDangerousGood: [
      { value: false, name: '-' },
      { value: true, name: 'Правила ЄЕК ООН №105-06' }
    ],
    presenceBrakeSystem: [
      { value: true, name: 'Так' },
      { value: false, name: 'Ні' }
    ]
  }),
  actions: {
    async getStatements (context, filter) {
      context.commit('SET_DATA', { store, state: 'isLoad', data: true })
      const response = await api.get(statement.statement + generateFilterParams(filter))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'statements', data: response.data })
      }
      context.commit('SET_DATA', { store, state: 'isLoad', data: false })
    },
    async getClientStatements (context, filter) {
      context.commit('SET_DATA', { store, state: 'isLoad', data: true })
      const response = await api.get(statement.clientStatement + generateFilterParams(filter))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'clientStatements', data: response.data })
      }
      context.commit('SET_DATA', { store, state: 'isLoad', data: false })
    },
    async getStatement (context, id) {
      const response = await api.get(`${ statement.statement }${ id }/`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'statement', data: response.data })
        return response.data
      }
      return false
    },
    async getCounterClientStatement (context) {
      const response = await api.get(statement.counterClientStatement)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'counterClientStatement', data: response.data })
        return response.data
      }
      return false
    },
    async getClientStatement (context, id) {
      const response = await api.get(`${ statement.clientStatement }${ id }/`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'clientStatement', data: response.data })
        return response.data
      }
      return false
    },
    async updateClientStatement (context, data) {
      const { id, ...body } = data
      const response = await api.patch(`${ statement.clientStatement }${ id }/`, { body })
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'clientStatement', data: response.data })
        return response.data
      }
      return false
    },
    async setStatement (context, body) {
      const response = body.vehicle_condition !== 'NewManual'
        ? await api.post(statement.statement, { body: body })
        : await api.post(statementManual.statementManual(), { body: body })
      if (await requestValidation(response)) {
        return response.data.id
      }
      return false
    },
    async updateStatement (context, body) {
      const response = await api.patch(statement.change(body.id), { body: body })
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getStatement', body.id)
      }
      return isResult
    },
    async getStatementPDF (context, data) {
      const response = await api.get(data.type === 'technical-control-statement' ?
        statement.pdfTechnicalControl(data.id) : statement.pdfStatement(data.id))
      if (await requestValidation(response)) {
        return response.data.url
      }
      return false
    },
    async getAgreementPDF (context, id) {
      const response = await api.get(statement.agreement(id))
      if (await requestValidation(response)) {
        return response.data.url
      }
      return false
    },
    async setStatementSign (context, id) {
      const response = await api.post(statement.statementSign, { body: { document: id } })
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getStatement', id)
        await context.dispatch('getIdentificationAct', id)
      }
      return isResult
    },

    async setClientSignature (context, data) {
      const body = new FormData()
      body.append('client_watermark', data.signatureFile)

      const response = await api.post(statement.clientSignature(data.id), { body: body })
      const isResult = await requestValidation(response)
      if (isResult) await context.dispatch('getStatement', data.id)
      return isResult
    },

    // решение по заявке
    async getDecisionForStatement (context, id) {
      const response = await api.get(statement.decision(id))
      const isResult = await requestValidation(response)
      if (isResult) context.commit('SET_DATA', { store, state: 'decision', data: response.data })
      else context.commit('SET_DATA', { store, state: 'decision', data: {} })
      return isResult
    },
    async setDecisionForStatement (context, data) {
      const response = await api.patch(statement.decisionAction(data.id), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        context.commit('SET_DATA', { store, state: 'decision', data: response.data })
        await context.dispatch('getStatement', data.id)
        // await context.dispatch('getDecision', data.decisionID)
      }
      return isResult
    },
    async getDecisionPDF (context, id) {
      const response = await api.get(statement.decisionPDF(id))
      if (await requestValidation(response)) {
        return response.data.url
      }
      return false
    },
    async setDecisionForStatementSign (context, data) {
      const response = await api.post(statement.decisionSign, { body: { document: data.decisionID } })
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getDecisionForStatement', data.id)
        await context.dispatch('getStatement', data.id)
      }
      return isResult
    },

    // рішення по акту ідентифікації ===================
    async getIdentificationAct (context, id) {
      const response = router.currentRoute.name !== 'statement-manual-item'
        ? await api.get(statement.identificationAct(id))
        : await api.get(statementManual.identificationAct(id))
      const isResult = await requestValidation(response)
      if (isResult) {
        router.currentRoute.name !== 'statement-manual-item'
          ? context.commit('SET_DATA', { store, state: 'identificationAct', data: response.data })
          : context.commit('SET_DATA', { store: 'statementManual', state: 'identificationAct', data: response.data })
      } else {
        context.commit('SET_DATA', { store, state: 'identificationAct', data: {} })
      }
    },

    async updateIdentificationAct (context, data) {
      const response = router.currentRoute.name !== 'statement-manual-item'
        ? await api.patch(statement.updateIdentificationAct(data.ids), { body: data.body })
        : await api.patch(statementManual.identificationAct(data.ids.statementId), { body: data.body })
      const isResult = await requestValidation(response)
      if (isResult) {
        await context.dispatch('getIdentificationAct', data.ids.statementId)
        router.currentRoute.name !== 'statement-manual-item'
          ? await context.dispatch('getStatement', data.ids.statementId)
          : await context.dispatch('getStatementManual', data.ids.statementId)
      }
      return isResult
    },

    identificationActMedia (context, data) {
      return Promise.all(data.items.map(async item => {
        return router.currentRoute.name !== 'statement-manual-item'
        ? await api.post(statement.identificationActMedia({ statementId: data.statementId, id: data.id }),
            { body: formData(item) })
        : await api.post(statementManual.uploadManualIdentificationActMedia({ statementId: data.statementId, id: data.id }),
            { body: formData(item) })
      })).then(response => response.every(async r => await requestValidation(r)))
    },

    async getIdentificationActPDF (context, id) {
      const response = router.currentRoute.name !== 'statement-manual-item'
        ? await api.get(statement.pdfIdentificationAct(id))
        : await api.get(statementManual.manualIdentificationActDocument(id))
      if (await requestValidation(response)) return response.data.url
      return false
    },

    async setClientSignatureIdentificationAct (context, data) {
      const body = new FormData()
      body.append('client_watermark', data.signatureFile)
      const response = router.currentRoute.name !== 'statement-manual-item'
        ? await api.post(statement.clientSignatureIdentificationAct({ statementId: data.statementId }), { body: body })
        : await api.post(statementManual.clientSignatureIdentificationAct({ statementId: data.statementId }), { body: body })
      const isResult = await requestValidation(response)
      if (isResult) {
        if (router.currentRoute.name !== 'statement-manual-item') {
          await context.dispatch('getIdentificationAct', data.statementId)
          await context.dispatch('getStatement', data.statementId)
        } else {
          await context.dispatch('getManualIdentificationAct', data.statementId)
          await context.dispatch('getStatementManual', data.statementId)
        }
      }
      return isResult
    },

    async setIdentificationActSign (context, data) {
      const response = router.currentRoute.name !== 'statement-manual-item'
        ? await api.post(statement.identificationActSign, { body: { document: data.id } })
        : await api.post(statementManual.identificationActSign, { body: { document: data.id } })
      const isResult = await requestValidation(response)
      if (isResult) {
        if (router.currentRoute.name !== 'statement-manual-item') {
          await context.dispatch('getIdentificationAct', data.statementId)
          await context.dispatch('getStatement', data.statementId)
        } else {
          await context.dispatch('getManualIdentificationAct', data.statementId)
          await context.dispatch('getStatementManual', data.statementId)
        }
      }
      return isResult
    },

    // ====================================

    async getVinDecode (context, vinCode) {
      const response = await api.get(statement.vinDecode(vinCode))

      if (response.code === 404) {
        let error = await response.data.json()
        context.commit('SET_DATA', { store, state: 'vinDecodeInfo', data: { error: error.detail } })
      } else {
        const isResult = await requestValidation(response)
        if (isResult) context.commit('SET_DATA', { store, state: 'vinDecodeInfo', data: { info: response.data } })
      }
    },

    async getEuroCodes (context, params) {
      const response = await api.get(statement.getEuroCodes(params))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'euroCodes', data: response.data })
      }
    },
    async getVehicleCategoryByParams (context, list) {
      list.forEach(async type => {
        const response = await api.get(statement.vehicleCategory + generateFilterParams({ [type]: true }))
        const isResult = await requestValidation(response)
        if (isResult) {
          context.commit('SET_DATA', { store, state: 'vehicleCategories', data: response.data })
        }
        return isResult
      })
    },
    async statementChangeResponsiblePerson (context, payload) {
      const response = await api.patch(statement.statementChangeResponsiblePerson(payload.statementId),
        { body: payload.assignedTo })
      const isResult = await requestValidation(response)
      if (isResult) await context.dispatch('getStatement', payload.statementId)
      return isResult
    }
  }
}
